Voonto.getInstance().define(['module'], function (module) {
    return {
        wakeUp($elm){
            Logger.info(`wake up module ${module.id}`);

            const app = Voonto.getInstance();

            let medio = $elm.data('edition');
            let metric_call = $elm.data('metric');

            let urlMetrics = app.lookup('vocento.config.nibara').metricsUrl;
            if (urlMetrics === undefined) {
                throw 'metricsUrl path in config is empty';
            }

            if (metric_call !== '') {
                urlMetrics += '?' + metric_call;
                if (medio === 'sevilla') {
                    urlMetrics += '&edition=sevilla';
                } else if (medio === 'abc') {
                    urlMetrics += '&edition=madrid';
                }
                if (urlMetrics.match(/pre.metrics|des.metrics/g)) {
                    urlMetrics += '&site=metrics.abc.es';
                }

                //Voonto.$.get(urlMetrics);
                /*try{
                    Voonto.$.ajax({
                        url: urlMetrics+'&callback=?',
                        dataType: "jsonp",
                        jsonpCallback: function (data) {
                            Logger.info('[Metrics ColC] success');
                        },
                        error: function(xhr, status, error) {
                            Logger.info('[Metrics ColC] error. ' + xhr.status + ' - error: ' + error);
                        }
                    });
                } catch (err) {
                    Logger.info('[Metrics ColC] error ');
                    Logger.info(err);
                }*/
                Voonto.$.ajax({
                    url: urlMetrics,
                    dataType: "jsonp"
                });
            }
        }
    }
});





// WEBPACK FOOTER //
// ./src/modules/metrics-colc-module.js